export const AuthenticationServiceTokens = Object.freeze({
    AuthenticationService: 'AuthenticationService',
    SessionManager: 'SessionManager',
    RedirectService: 'RedirectService',
    PlatformResolutionService: 'PlatformResolutionService',
    ResetSessionDataService: 'ResetSessionDataService',
    SessionApiClient: 'SessionApiClient',
    ActivateUserService: 'ActivateUserService',
    AuthFlowStoreService: 'AuthFlowStoreService',
    ForgotPasswordService: 'ForgotPasswordService',
    ResetPasswordService: 'ResetPasswordService',
    LogoutUseCase: 'LogoutUseCase',
} as const);
